<template>
  <div>
    <va-modal
      :value="showModal"
      id="createMeasurementModal"
      ref="createMeasurementModal"
      size="large"
      :showOkay="false"
      @cancel="$emit('cancel')"
      :cancelText="$t('leads.back')"
      :noDismiss="true"
      :no-outside-dismiss="false"
      :fixedLayout="true">
      <div slot="header" class="modal-title d-flex justify--space-between pb-0 mb-0">
        <h3>{{ $t(`dashboard_new_evollu.parameters.${measurementData.measurementType}`) }}</h3>
      </div>

      <div v-if="parsedAnswers.length && parsedAnswers.length > 0" class=" mb-">
        <div v-for="answer in parsedAnswers" :key="answer.id">
          <div class="d-flex q-a">
            <div class="col-12 col-md-8">
        <span class="q-a question">
          <p>{{answer.question}}</p>
        </span>
            </div>
            <div class="col-12 col-md-4">
        <span class="q-a answer">
          <p>{{answer.answer}}</p>
        </span>
            </div>
          </div>
          <hr class="separator">
        </div>
      </div>
      <div v-else class="d-flex justify-content-center">
        <h5 class="text-black-50">{{$t('leads.details.no_answer')}}</h5>
      </div>

    </va-modal>

  </div>
</template>

<script>
export default {
  props: {
    measurementData: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      showModal: false
    }
  },
  mounted() {
    this.showModal = true
  },
  computed: {
    parsedAnswers: function() {
      let answers = []
      if(this.measurementData && this.measurementData.questionsValues && Object.keys(this.measurementData.questionsValues).length > 0) {
        Object.keys(this.measurementData.questionsValues).forEach(key => {
          const value = this.measurementData.questionsValues[key].toString().trim()
          answers.push({
            question: this.$t(`dashboard_new_evollu.measurement_types.questions.${key}`),
            answer: this.$t(`checkup_plus.questionnaires.answers_by_type_id.${key}.${value}`)
          })
        })
      }
      return answers
    }
  }
}

</script>

<style lang="scss" scoped>

.q-a {
  margin: 0.2rem;
  p {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }
}

.question {
  // width: 85%;
  width: calc(100% - 85px);
  margin-right: 0.5rem;
}

.answer p {
  color: $evollu-dark;
  font-weight: bold;
}

.separator {
  margin: 0.2rem;
}
</style>
